import * as RadixTabs from "@radix-ui/react-tabs";
import { cn } from "../lib/utils";

export type TabItem = {
  id: string;
  title: string;
  component: any;
};

export default function Tabs({ categories }: { categories: TabItem[] }) {
  return (
    <RadixTabs.Root defaultValue={categories[0]?.id} className="w-full">
      <RadixTabs.List className="flex border-b border-[var(--sc-border)] bg-transparent gap-0">
        {categories.map((category) => (
          <RadixTabs.Trigger
            key={category.id}
            value={category.id}
            className={cn(
              "px-5 py-2.5 text-sm font-medium text-[var(--sc-muted)] border-b-2 border-transparent",
              "-mb-px transition-colors cursor-pointer bg-transparent",
              "hover:text-[var(--sc-text)]",
              "data-[state=active]:text-[var(--sc-text)] data-[state=active]:border-[var(--sc-text)]",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--sc-amber)]"
            )}
          >
            {category.title}
          </RadixTabs.Trigger>
        ))}
      </RadixTabs.List>

      {categories.map((category) => (
        <RadixTabs.Content
          key={category.id}
          value={category.id}
          className="pt-4 focus-visible:outline-none"
        >
          {category.component}
        </RadixTabs.Content>
      ))}
    </RadixTabs.Root>
  );
}

